const STEAM_STORE_HOST = "store.steampowered.com";
const STEAM_APP_PATH_REGEXES = [
  /^\/app\/(\d+)(?:\/|$)/i,
  /^\/agecheck\/app\/(\d+)(?:\/|$)/i,
  /^\/[a-z]{2}(?:-[a-z]{2})?\/app\/(\d+)(?:\/|$)/i,
];
const STEAM_RUN_GAME_HOST = "rungameid";
const STEAM_RUN_HOST = "run";
const STEAM_LAUNCH_HOST = "launch";
const STEAM_NUMERIC_PATH_REGEX = /^\/(\d+)(?:\/|$)/i;

function safeParseUrl(rawUrl) {
  if (!rawUrl || typeof rawUrl !== "string") {
    return null;
  }

  try {
    return new URL(rawUrl);
  } catch (error) {
    return null;
  }
}

function normalizeHostname(hostname) {
  if (!hostname || typeof hostname !== "string") {
    return "";
  }

  return hostname.toLowerCase().replace(/^www\./, "");
}

function extractAppIdFromStorePath(pathname) {
  if (!pathname || typeof pathname !== "string") {
    return null;
  }

  for (const steamAppRegex of STEAM_APP_PATH_REGEXES) {
    const match = pathname.match(steamAppRegex);
    if (match) {
      return match[1];
    }
  }

  return null;
}

export function extractSteamAppId(rawUrl) {
  const parsedUrl = safeParseUrl(rawUrl);
  if (!parsedUrl) {
    return null;
  }

  const normalizedHostname = normalizeHostname(parsedUrl.hostname);
  const isSteamStore = normalizedHostname === STEAM_STORE_HOST;
  if (isSteamStore) {
    return extractAppIdFromStorePath(parsedUrl.pathname);
  }

  const isSteamDeepLink = parsedUrl.protocol === "steam:";
  const isSupportedSteamHost =
    normalizedHostname === STEAM_RUN_GAME_HOST ||
    normalizedHostname === STEAM_RUN_HOST ||
    normalizedHostname === STEAM_LAUNCH_HOST;

  if (isSteamDeepLink && isSupportedSteamHost) {
    const match = parsedUrl.pathname.match(STEAM_NUMERIC_PATH_REGEX);
    return match ? match[1] : null;
  }

  return null;
}

export function isSteamStoreUrl(rawUrl) {
  return Boolean(extractSteamAppId(rawUrl));
}

export function getSteamDeepLinkFromStoreUrl(rawUrl) {
  const parsedUrl = safeParseUrl(rawUrl);
  if (
    parsedUrl &&
    parsedUrl.protocol === "steam:" &&
    parsedUrl.hostname === STEAM_RUN_GAME_HOST
  ) {
    return parsedUrl.toString();
  }

  const appId = extractSteamAppId(rawUrl);
  return appId ? `steam://rungameid/${appId}` : null;
}
